import FormFieldValidationError from './FormFieldValidationError';
import FormValidationError from './FormValidationError';
export default class FormValidationResults {
    constructor() {
        this.errors = [];
        this.fieldErrors = [];
    }
    /** Get the global form errors */
    getErrors() {
        return this.errors;
    }
    /** Get errors for the individual fields */
    getFieldErrors() {
        return this.fieldErrors;
    }
    /** Push an general form not for a specific field. */
    pushFormError(error) {
        this.errors.push(new FormValidationError(error));
    }
    /** Error for a specific field */
    pushFieldError(error) {
        this.fieldErrors.push(new FormFieldValidationError(error));
    }
    /** Return true if this form has errors. */
    hasErrors() {
        return this.errors.length > 0 || this.fieldErrors.length > 0;
    }
}
